import { initializeApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const missingKeys = Object.entries(firebaseConfig)
  .filter(([, value]) => !value)
  .map(([key]) => key);
const appCheckSiteKey = process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY;
const appCheckDebugToken = process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG_TOKEN;

if (missingKeys.length > 0) {
  // eslint-disable-next-line no-console
  console.error(
    `Firebase config is incomplete for admin build. Missing: ${missingKeys.join(", ")}. ` +
      "Make sure REACT_APP_FIREBASE_* variables are present during build."
  );
}

export const app = initializeApp(firebaseConfig);

if (appCheckSiteKey) {
  if (
    appCheckDebugToken &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1")
  ) {
    (globalThis as typeof globalThis & {
      FIREBASE_APPCHECK_DEBUG_TOKEN?: string | boolean;
    }).FIREBASE_APPCHECK_DEBUG_TOKEN =
      appCheckDebugToken === "true" ? true : appCheckDebugToken;
  }

  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
} else {
  // eslint-disable-next-line no-console
  console.warn(
    "REACT_APP_FIREBASE_APPCHECK_SITE_KEY is missing; App Check is disabled in this build."
  );
}

export const auth = getAuth(app);
export const functions = getFunctions(app, "us-east1");
